/** The product-tour mark, shared across the working app's page headers. */
export function AppMark() {
  return <svg className="app-mark" viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect width="32" height="32" rx="9" fill="currentColor" /><path d="M9 10h14M16 10v13M10 18l4 5 9-11" stroke="white" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
